module.exports = __webpack_public_path__ + "img/12600.50304f81.jpg";